import { render, staticRenderFns } from "./RoleSetting.vue?vue&type=template&id=bcde4d7e&scoped=true&"
import script from "./RoleSetting.vue?vue&type=script&lang=js&"
export * from "./RoleSetting.vue?vue&type=script&lang=js&"
import style0 from "./RoleSetting.vue?vue&type=style&index=0&id=bcde4d7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcde4d7e",
  null
  
)

export default component.exports